import Component from '../app/component'
import gsap from 'gsap'
import barba from '@barba/core'
import mediaQueries from '../plugins/media-queries.js'

export default class TopComponent extends Component {
	constructor(el) {
		super(el)
		this.data = {
			interactions: true,
			navDisplay: false,
			style: null,
			title: null
		}
	}
	
	init() {
		this.refs.menuItems = Array.from(this.el.querySelectorAll('.head__nav li'))
		if (this.refs.menu) {
			this.refs.menu.addEventListener('click', () => this.toggleNav())
		}
		if (this.refs.close) {
			this.refs.close.addEventListener('click', () => this.toggleNav())
		}
		
		// loader event
		const loaderIgnore = sessionStorage.getItem('loaderIgnore')
		document.addEventListener('loader.end', () => {
			this.el.classList.add('cm-top--active')
			if (!loaderIgnore) {
				this.tweenIn()
			}
		})
		
		// mobile classes
		document.addEventListener('top.mobilenav.in', () => {
			this.el.classList.add('cm-top--mobilenav')
		})
		document.addEventListener('top.mobilenav.out', () => {
			this.el.classList.remove('cm-top--mobilenav')
		})
		
		// first launch style
		this.data.style = this.el.classList.contains('cm-top--dark') ? 'dark' : 'light'
		
		// barba hook
		barba.hooks.afterLeave(data => {
			// change top style
			this.data.style = ['home'].includes(data.next.namespace) ? 'dark' : 'light'
			// close nav
			if (this.data.navDisplay) {
				this.toggleNav()
			}
			// get title
			const nextDocument = new DOMParser().parseFromString(data.next.html, 'text/html')
			const topTitle = nextDocument.querySelector('.head__title h1')
			if (topTitle) {
				this.data.title = topTitle.textContent ? topTitle.textContent : ''
			}
		})
	}
	
	watchStyle(value) {
		if (!['light', 'dark'].includes(value)) {
			return
		}
		
		if (value === 'light') {
			this.el.classList.remove('cm-top--dark')
			this.el.classList.add('cm-top--light')
		} else {
			this.el.classList.add('cm-top--dark')
			this.el.classList.remove('cm-top--light')
		}
	}
	
	watchTitle(value) {
		if (typeof value !== 'string') {
			this.refs.title.textContent = 'Redmark';
			this.refs.title.classList.add('hide');
			return
		}
		if (this.refs.title) {
			this.refs.title.classList.remove('hide');
			this.refs.title.textContent = value
		}
	}
	
	async tweenIn() {
		const tl = gsap.timeline()
		const elements = []
		
		if (this.refs.logo) {
			elements.push(this.refs.logo)
		}
		if (this.refs.title) {
			elements.push(this.refs.title)
		}
		if (this.refs.menu) {
			elements.push(this.refs.menu)
		}
		
		tl.fromTo(
			elements,
			{
				opacity: 0,
				yPercent: -120
			},
			{
				opacity: 1,
				yPercent: 0,
				duration: 1.25,
				ease: 'power2.inOut',
				clearProps: 'all'
			},
			0
		)
		
		return tl.then()
	}
	
	async toggleNav() {
		if (!this.data.interactions) {
			return
		}
		if (mediaQueries.test('small')) {
			document.dispatchEvent(new CustomEvent('mobilenav.toggle'))
			return
		}
		
		const tl = gsap.timeline({
			onComplete: () => {
				this.data.interactions = true
				if (!this.data.navDisplay) {
					this.refs.nav.classList.remove('show')
				}
			}
		})
		
		this.data.interactions = false
		this.data.navDisplay = !this.data.navDisplay
		
		if (this.data.navDisplay) {
			this.refs?.nav.classList.add('show')
		}
		
		if (this.refs?.menuItems?.length) {
			console.log('--->>>>', this.data.navDisplay)
			tl.fromTo(
				this.refs.menuItems,
				{
					yPercent: this.data.navDisplay ? -100 : 0
				},
				{
					yPercent: this.data.navDisplay ? 0 : -100,
					duration: 0.8,
					ease: 'power4.inOut',
					stagger: 0.05
				},
				0
			)
		}
		
		if (this.refs.close) {
			tl.fromTo(
				this.refs.close,
				{
					opacity: this.data.navDisplay ? 0 : 1,
					yPercent: this.data.navDisplay ? -100 : 0,
					pointerEvents: this.data.navDisplay ? 'auto' : 'none'
				},
				{
					opacity: this.data.navDisplay ? 1 : 0,
					yPercent: this.data.navDisplay ? 0 : -100,
					duration: 0.75,
					ease: 'power2.inOut'
				},
				0
			)
		}
		
		if (this.refs.title) {
			tl.fromTo(
				this.refs.title,
				{
					opacity: this.data.navDisplay ? 1 : 0,
					yPercent: this.data.navDisplay ? 0 : -100
				},
				{
					opacity: this.data.navDisplay ? 0 : 1,
					yPercent: this.data.navDisplay ? -100 : 0,
					duration: 0.75,
					ease: 'power2.inOut'
				},
				0
			)
		}
		
		if (this.refs.menu) {
			tl.fromTo(
				this.refs.menu,
				{
					opacity: this.data.navDisplay ? 1 : 0,
					yPercent: this.data.navDisplay ? 0 : -25
				},
				{
					opacity: this.data.navDisplay ? 0 : 1,
					yPercent: this.data.navDisplay ? -25 : 0,
					duration: this.data.navDisplay ? 0.5 : 1,
					ease: 'power2.inOut'
				},
				0
			)
		}
		
		if (this.refs.langs) {
			tl.fromTo(
				this.refs.langs,
				{
					opacity: this.data.navDisplay ? 1 : 0,
					yPercent: this.data.navDisplay ? 0 : -25
				},
				{
					opacity: this.data.navDisplay ? 0 : 1,
					yPercent: this.data.navDisplay ? -25 : 0,
					duration: this.data.navDisplay ? 0.5 : 1,
					ease: 'power2.inOut'
				},
				0
			)
		}
		
		return tl.then()
	}
}
